import { useEffect, useState } from "react";
import { userStore } from "../store/userStore";
import logo from "../assets/images/logo-viziona-white.png";
import { sessionStatus } from "../services/auth";
import { useSettingsStore } from "../context/useSettingsStore";
import { useGetSetting } from "../hooks/useSettingsQueries";

const SessionLayout = ({ children }) => {
  const { maxSeats } = useSettingsStore();
  const { refetch } = useGetSetting();
  const kioskData = userStore((state) => state.kioskData);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const validateSession = async () => {
      await sessionStatus();
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    };
    validateSession();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (maxSeats === 0) {
      refetch();
    }
  }, [refetch, maxSeats]);

  return (
    <>
      {!kioskData && loading ? (
        <div className="session-valdiate purple-gradient-inverted">
          <img src={logo} alt="logo" />
          <h4>Espera un momento estamos validando tu sesión...</h4>
        </div>
      ) : (
        children
      )}
    </>
  );
};

export default SessionLayout;
